/* eslint-disable no-constant-condition */
import { takeEvery, takeLatest, take, put, call, /*fork,*/ /*select,*/ all, delay } from 'redux-saga/effects'
import { loginServices } from '../services'
import Cookies from 'js-cookie';
import _ from 'lodash'
import * as CONSTANTS from '../constants/constants'
import { API_URL_SERVICE, API_URL_FRONT/*, API_URL*/ } from '../constants/config';
export function* checkToken(payload) {
  try {
    if (window.location.href === API_URL_FRONT)
      return;

    let token = Cookies.getJSON("account").token

    //const result = yield call(loginServices.postCall, API_URL_SERVICE + '/menu_provider/api/check-token', token);
    const result = yield call(loginServices.loginGET, API_URL_SERVICE + '/oauth2/oauth/check_token?token=' + token);

    if (result.error !== "invalid_token")
      yield put({ type: CONSTANTS.LOGGED, userData: result });
    else
      window.location.href = API_URL_FRONT;
  } catch (e) {
    console.log("CHECK TOKEN ERROR - TOKEN INVALID")
    Cookies.remove("account")
    window.location.href = API_URL_FRONT;

  }
}

export function* getMenu() {
  try {
    const result = yield call(loginServices.getCall, API_URL_SERVICE + '/menu_provider/api/menu/portal', null);
    //const result = yield call(loginServices.getCall, 'https://septest.colonseguros.com.ar' +'/menu_provider/api/menu/portal', null);
    yield put({ type: CONSTANTS.MENU_SUCCESS, response: result });
  } catch (e) {
    yield put({ type: (e.error === "invalid_token" ? CONSTANTS.CHECK_TOKEN : CONSTANTS.MENU_ERROR), message: e.message });
  }
}

function isProducer() {
  const account = Cookies.getJSON("account");
  if (!account) return false;
  const userRoles = account.userRoles || JSON.parse(localStorage.getItem('userRoles') || '[]');
  if (!userRoles || userRoles.length === 0) return false;
  return _.find(userRoles, (item) => { return item.authority === "ROLE_PRODUCER" }) !== undefined
}

/* post secure */
export function* getIntermediarios(payload) {
  try {
    let baseUrl = API_URL_SERVICE + '/menu_provider';
    let cuit = payload.cuit || Cookies.getJSON("account")?.cuit;

    const producer = payload.isProducer !== undefined ? payload.isProducer : isProducer();
    let url = producer ? `${baseUrl}/api/intermediarios` : `${baseUrl}/api/intermediarios/admproducer`
    console.log('[getIntermediarios] cuit:', cuit, '| isProducer:', producer, '| url:', url, '| token desde payload:', !!payload.token);
    const result = payload.token
      ? yield call(loginServices.postCallWithToken, url, JSON.stringify({ cuit: Number.parseInt(cuit) }), payload.token)
      : yield call(loginServices.postCall, url, JSON.stringify({ cuit: Number.parseInt(cuit) }));
    //const result = yield call(loginServices.postCall,`https://septest.colonseguros.com.ar/gestor-cotizador-emisor-services/api/gaus/intermediarios`, cuit);
    console.log('[getIntermediarios] resultado:', JSON.stringify(result));
    yield put({ type: CONSTANTS.INTERMEDIARIOS_SUCCESS, userData: result });
  } catch (e) {
    yield put({ type: (e.error === "invalid_token" ? CONSTANTS.CHECK_TOKEN : CONSTANTS.INTERMEDIARIOS_ERROR), message: e.message });
  }
}

/* post secure */
export function* getIntermediariosSearch(payload) {
  try {
    //const result = yield call(loginServices.postCall,`${API_URL_SERVICE}/gestor-cotizador-emisor-services/api/gaus/intermediarios/backoffice`, payload.payload.search);
    //let baseUrl = 'http://localhost:8010'
    let baseUrl = API_URL_SERVICE + '/menu_provider';
    const result = yield call(loginServices.postCall, `${baseUrl}/api/intermediarios/backoffice`, JSON.stringify({ search: payload.payload.search }));
    //const result = yield call(loginServices.postCall,`https://septest.colonseguros.com.ar/gestor-cotizador-emisor-services/api/gaus/intermediarios/backoffice`, payload.payload.search);
    yield put({ type: CONSTANTS.INTERMEDIARIOS_SEARCH_SUCCESS, userData: result });
  } catch (e) {
    //console.log("error: " ,(e.error === "invalid_token" ? CONSTANTS.CHECK_TOKEN : CONSTANTS.INTERMEDIARIOS_SEARCH_ERROR))
    yield put({ type: (e.error === "invalid_token" ? CONSTANTS.CHECK_TOKEN : CONSTANTS.INTERMEDIARIOS_SEARCH_ERROR), message: e.message });
  }
}

export function* impersonalizar(payload) {
  try {
    //const result = yield call(loginServices.postCall,`${API_URL_SERVICE}/gestor-cotizador-emisor-services/api/gaus/intermediarios/impersonalizar`, JSON.stringify(payload.payload));
    //let baseUrl = 'http://localhost:8010'
    let baseUrl = API_URL_SERVICE + '/menu_provider';
    console.log('[impersonalizar] payload.payload:', JSON.stringify(payload.payload));
    const result = payload.token
      ? yield call(loginServices.postCallWithToken, `${baseUrl}/api/intermediarios/impersonalizar`, JSON.stringify(payload.payload), payload.token)
      : yield call(loginServices.postCall, `${baseUrl}/api/intermediarios/impersonalizar`, JSON.stringify(payload.payload));
    //const result = yield call(loginServices.postCall,`https://septest.colonseguros.com.ar/gestor-cotizador-emisor-services/api/gaus/intermediarios/impersonalizar`, JSON.stringify(payload.payload));
    console.log('[impersonalizar] resultado:', JSON.stringify(result));
    yield put({ type: CONSTANTS.IMPERSONALIZAR_SUCCESS, userData: result });
  } catch (e) {
    yield put({ type: (e.error === "invalid_token" ? CONSTANTS.CHECK_TOKEN : CONSTANTS.IMPERSONALIZAR_ERROR), message: e.message });
  }
}

export function* logout() {
  try {
    //const result = yield call(loginServices.getCall, 'http://localhost:8090' + '/api/login/logout', null);
    //let baseUrl = 'http://localhost:8010'
    let baseUrl = API_URL_SERVICE + '/menu_provider';
    //const result = yield call(loginServices.getCall, API_URL_SERVICE + '/ov_services/api/login/logout', null);
    const result = yield call(loginServices.getCall, `${baseUrl}/security/logout`, null);
    yield put({ type: CONSTANTS.LOGOUT_SUCCESS, response: result });
  } catch (e) {
    yield put({ type: (e.error === "invalid_token" ? CONSTANTS.CHECK_TOKEN : CONSTANTS.LOGOUT_ERROR), message: e.message });
  }
}

export function* verifyTokenValidity() {
  //yield redirectToLogin()
}


export function* login(payload) {
  try {
    let baseUrl = API_URL_SERVICE + '/menu_provider';
    const result = yield call(loginServices.loginPOST, `${baseUrl}/security/check-token`, payload);

    console.log('[check-token saga result]', result);
    console.log('[check-token saga result.response]', result?.response);

    let loginResult;
    if (!result.response) {
      console.log('[check-token] entro al IF (no response)');
      const shouldContinue = yield call(showConfirmationModal);
      if (!shouldContinue) {
        yield put({ type: CONSTANTS.CHECK_TOKEN });
        return;
      }
      loginResult = yield call(loginServices.loginPOST, `${baseUrl}/security/login`, payload);
    } else {
      console.log('[check-token] entro al ELSE (response existe)');
      loginResult = result;
    }

    const loginData = loginResult.response;
    const cuit = loginData?.cuit;
    const token = loginData?.access_token;
    const tipoAgente = loginData?.tipoAgente;
    const isProducerUser = loginData?.authorities?.some(a => a.authority === "ROLE_PRODUCER") ?? false;
    const esMaster = tipoAgente === '20';

    const isImpers = loginData?.isImpersonalised === true || loginData?.isImpersonalized === true;
    console.log('[login] isImpers (backend auto-impersonalizó):', isImpers);

    console.log('[login] loginData.cuit:', cuit);
    console.log('[login] loginData.agentCode:', loginData?.agentCode);
    console.log('[login] loginData.tipoAgente:', tipoAgente);
    console.log('[login] isProducerUser:', isProducerUser);
    console.log('[login] esMaster:', esMaster);

    console.log('[login] loginData que va al store:', JSON.stringify({
    tipoAgente: loginData?.tipoAgente,
    isImpersonalised: loginData?.isImpersonalised,
    agentCode: loginData?.agentCode,
    codigoAgenteImpersonalizado: loginData?.codigoAgenteImpersonalizado
    }));

    yield put({ type: CONSTANTS.LOGIN_SUCCESS, response: loginResult });

    let intermediarioPrincipal = null;

    if (esMaster && !isImpers) {
      const url = isProducerUser ? `${baseUrl}/api/intermediarios` : `${baseUrl}/api/intermediarios/admproducer`;
      console.log('[login] llamando intermediarios directo con token, url:', url);
      const intermediariosResult = yield call(
        loginServices.postCallWithToken,
        url,
        JSON.stringify({ cuit: Number.parseInt(cuit) }),
        token
      );
      console.log('[login] intermediarios recibidos:', JSON.stringify(intermediariosResult));
      yield put({ type: CONSTANTS.INTERMEDIARIOS_SUCCESS, userData: intermediariosResult });
      const intermediarios = intermediariosResult?.response;
      if (intermediarios && intermediarios.length > 0) {
        const propios = intermediarios.filter(i => i.cuit === cuit && i.tipoAgente === '1');
        const orgCode = loginData?.organization?.replace('ADMINSE_', '');
        intermediarioPrincipal = propios.find(i => i.codigoAgente === orgCode)
          || propios.sort((a, b) => Number(a.codigoAgente) - Number(b.codigoAgente))[0]
          || intermediarios[0];

        console.log('[login] intermediarioPrincipal seleccionado:', JSON.stringify(intermediarioPrincipal));

        const impersonalizarResult = yield call(
          loginServices.postCallWithToken,
          `${baseUrl}/api/intermediarios/impersonalizar`,
          JSON.stringify(intermediarioPrincipal),
          token
        );
        console.log('[login] impersonalizacion resultado:', JSON.stringify(impersonalizarResult));
        yield put({ type: CONSTANTS.IMPERSONALIZAR_SUCCESS, userData: impersonalizarResult });
      }
    } else if (isImpers) {
      console.log('[login] Usando datos de impersonalización del backend');
        yield put({
          type: CONSTANTS.IMPERSONALIZAR_SUCCESS,
          userData: { response: {
            codigoAgente: loginData.agentCode || loginData.codigoAgenteImpersonalizado,
            nombre: loginData.agentName,
            tipoAgente: loginData.tipoAgente
          }}
        });
        intermediarioPrincipal = {
          codigoAgente: loginData.agentCode || loginData.codigoAgenteImpersonalizado,
          nombre: loginData.agentName
        };
    }

    console.log('[login] despachando LOGIN_READY con agentCode:', intermediarioPrincipal?.codigoAgente, '| agentName:', intermediarioPrincipal?.nombre);
    yield put({
      type: CONSTANTS.LOGIN_READY,
      agentCode: intermediarioPrincipal?.codigoAgente,
      agentName: intermediarioPrincipal?.nombre
    });

  } catch (e) {
    console.log('[check-token] CAI AL CATCH', e);
    yield put({ type: (e.error === "invalid_token" ? CONSTANTS.CHECK_TOKEN : CONSTANTS.LOGIN_ERROR), message: e.message });
  }
}



export function* showConfirmationModal() {
  const shouldContinue = window.confirm('Lo siento, pero parece que ya tienes una sesión abierta en tu cuenta.\n\n¿Deseas iniciar una nueva sesión y cerrar tu sesión previa?');
  return shouldContinue;
}

export default function* root() {

  yield takeEvery(CONSTANTS.MENU_LOADING, getMenu)
  yield takeEvery(CONSTANTS.LOGIN_LOADING, login)
  yield takeEvery(CONSTANTS.VALIDATE_TOKEN, verifyTokenValidity)
  yield takeEvery(CONSTANTS.LOGOUT_LOADING, logout)
  yield takeEvery(CONSTANTS.INTERMEDIARIOS_LOADING, getIntermediarios)
  yield takeLatest(CONSTANTS.INTERMEDIARIOS_SEARCH_LOADING, getIntermediariosSearch)
  yield takeEvery(CONSTANTS.IMPERSONALIZAR_LOADING, impersonalizar)
  yield takeEvery(CONSTANTS.CHECK_TOKEN, checkToken)
  yield all([])
}

